"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitials = void 0;
var getInitials = function getInitials(name) {
  var parts = name.trim().split(/\s/);
  return "" + parts[0].charAt(0) + (parts.length > 1 ? parts[parts.length - 1].charAt(0) : '');
};
exports.getInitials = getInitials;